var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 411,
    viewBox: "0 0 451 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_91_30908",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 341,
    height: 348
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0H302L342 109L274 113.5L172.5 216V283V348L1 333L1 0Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_91_30908)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_91_30908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.75 23.4583C55.1083 23.4583 38.375 40.1917 38.375 60.8332V260.167C38.375 280.809 55.1084 297.542 75.75 297.542H237.708C258.351 297.542 275.083 280.809 275.083 260.167V135.583C275.083 132.279 273.77 129.11 271.434 126.774L171.768 27.1075C170.575 25.9153 169.166 24.9894 167.634 24.3687C166.163 23.7731 164.577 23.4583 162.958 23.4583H75.75ZM150.5 48.3749H75.75C68.8694 48.3749 63.2917 53.9526 63.2917 60.8332V260.167C63.2917 267.047 68.8695 272.625 75.75 272.625H237.708C244.589 272.625 250.167 267.047 250.167 260.167V148.042H162.958C156.078 148.042 150.5 142.464 150.5 135.583V48.3749ZM232.548 123.125L175.417 65.994V123.125H232.548Z",
    fill: "#FFF5E0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_91_30908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.25 92.4583C376.892 92.4583 393.625 109.192 393.625 129.833V329.167C393.625 349.809 376.892 366.542 356.25 366.542H194.292C173.649 366.542 156.917 349.809 156.917 329.167V204.583C156.917 201.279 158.23 198.11 160.566 195.774L260.232 96.1075C261.425 94.9153 262.834 93.9894 264.366 93.3687C265.837 92.7731 267.423 92.4583 269.042 92.4583H356.25ZM281.5 117.375H356.25C363.131 117.375 368.708 122.953 368.708 129.833V329.167C368.708 336.047 363.13 341.625 356.25 341.625H194.292C187.411 341.625 181.833 336.047 181.833 329.167V217.042H269.042C275.922 217.042 281.5 211.464 281.5 204.583V117.375ZM199.452 192.125L256.583 134.994V192.125H199.452Z",
    fill: "#FFE4FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_91_30908",
    x: 16.7472,
    y: 1.83043,
    width: 279.964,
    height: 317.339,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8139
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.683333 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_30908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_30908",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_91_30908",
    x: 135.289,
    y: 70.8304,
    width: 279.964,
    height: 317.339,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.8139
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.816667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_30908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_30908",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1D);
export default __webpack_public_path__ + "static/media/step1d.fcc566f43648076b9646315539052681.svg";
export { ForwardRef as ReactComponent };